
export const Authorities = {

  Admin: "Admin",
  CityManager: "CityManager",

};
